<template>
    <div>
        <h2>{{slide.type}} Question:</h2>
        <hr>
        <quill-editor 
            @blur="saveSlide()"
            v-model="slide.slide.corpus"
            ref="quillCKQuestionEditor"
            :options="{'placeholder': 'Write question here...'}"
        ></quill-editor>
        <ResourceGallery :resourceList="slide.slide.resources" v-on:saveSlide="saveSlide(false)"></ResourceGallery>
        <hr>
        <h2>{{slide.type}} Options:</h2>
        <draggable 
        :options="{handle :'.drag-handle'}" 
        style="display: table; margin: auto;" 
        :list="slide.options" 
        @start="drag=true" @end="drag=false; saveSlide()" 
        @update="checkMove">
            <div v-for="(opt, index) in slide.options" :key="opt.id" style="display: inline-block; float: left; clear: both;">
                <md-icon class="drag-handle">drag_handler</md-icon>
                <md-checkbox 
                v-model="slide.answer_option_id" 
                :value="opt.id" 
                @change="saveSlide()"
                class="md-primary">
                </md-checkbox>
                <input 
                v-model="opt.corpus" 
                @blur="saveSlide()" 
                style="width: 300px; margin-right: 10px;"/>
                <span @click="deleteOption(index)">
                    <md-icon>cancel</md-icon>
                </span>
                {{opt.order}}
                <br>
            </div>
            <br>
        </draggable>
        <md-button class="md-primary md-raised" @click="addOption()" jest="add-opt-btn" style="margin-top: 20px">
            Add Checklist Option
        </md-button>
        <br><br>
        <hr>
        <h2>Feedback:</h2>
        <quill-editor 
            @blur="saveSlide()"
            v-model="slide.answer"
            :options="{'placeholder': 'Write feedback here...'}"
        ></quill-editor>
        <CitationManager :citations="slide.slide.citations" @save="saveSlide(false)"/>
        <ResourceGallery :resourceList="slide.a_resources" v-on:saveSlide="saveSlide(false)"></ResourceGallery>
        <hr>
        <md-button class="md-raised md-primary" @click="saveSlide(true)" style="background-color: green">
            Save
        </md-button>
        <md-button class="md-raised md-accent md-icon-button slide-delete-btn" @click="deleteSlide()">
            <md-icon>delete_forever</md-icon>
        </md-button>
    </div>
</template>

<script>

import ResourceGallery from './Gallery.vue'
import CitationManager from './CitationManager.vue'
const ObjectID = require("bson-objectid");
import draggable from 'vuedraggable'

export default {
    props: {
        slide: {
            type: Object
        },
        complete: {
            type: Boolean
        }
    },
    data: function(){
        return {
        }
    },
    components: {
        draggable,
        ResourceGallery,
        CitationManager
    },
    methods: {
        /**
         * saveSlide emits an event which tells the parent component to save the data for this slide to the DB
         * @param {bool} closeSlide determines whether the slide editor will close after save.
        */
        saveSlide: function(closeSlide) {
            this.$emit('saveSlide', [this.slide, closeSlide])
        },
        deleteSlide: function(){
            this.$emit('deleteSlide', this.slide)
        },
        //resetOptionOrder recalculates the multiple choice option "order" value
        resetOptionOrder: function(){
            if(!this.slide.options) return
            for (var i = 0; i < this.slide.options.length; i++) {
                this.slide.options[i].order = i+1
            }
        },
        /**
         * checkMove is ued to apply all the changes after an option is dragged
        */
        checkMove: function(){
            this.resetOptionOrder()
            this.saveSlide(false)
        },
        /**
         * addOption allows the user to create a new option on their MC question.
        */
        addOption: function(){
            var id  = ObjectID();
            if(!this.slide.options) this.$set(this.slide, "options", [])
            this.slide.options.push({
                id: id.toString(),
                order: this.slide.options.length + 1
            })
            this.saveSlide()
        },
        /**
         * deleteOption allows the user to delete an option from their MC question
         * @param {int} optIndex index of option to be deleted
        */
        deleteOption: function(optIndex){
            if(!this.slide.options) return
            this.slide.options.splice(optIndex, 1);
            this.resetOptionOrder()
            this.saveSlide()
        },       
        clearQuillHistory() {
            this.$refs.quillCKQuestionEditor.quill.history.clear();
        }
    },
    mounted() {
        this.$nextTick(function(){
            this.clearQuillHistory();
        })
    },
    watch: {
        "slide.id"() {
            setTimeout(() => {
                this.clearQuillHistory();
            }, 500)
        }
    }
}
</script>

<style scoped>
.md-field{
    max-width: 80%;
    margin: auto;
    margin-bottom: 40px;
}
.drag-handle{
    cursor: move;
    padding: 13px 20px 20px 40px;
}
</style>